var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "fixed width-100 z-99" },
        [
          _c(
            "van-tabs",
            {
              model: {
                value: _vm.tabIndex,
                callback: function ($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex",
              },
            },
            [
              _c("van-tab", { attrs: { title: "发起提交" } }),
              _c("van-tab", { attrs: { title: "查看数据" } }),
              _c("van-tab", { attrs: { title: "席位总览" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "h-98" }),
      _vm.tabIndex === 1
        ? _c("list", { ref: "list", on: { change: _vm.listChange } })
        : _vm._e(),
      _vm.tabIndex === 0 ? _c("addOrUpdate", { ref: "addOrUpdate" }) : _vm._e(),
      _vm.tabIndex === 2
        ? _c("seatOverview", {
            ref: "seatOverview",
            on: { reserving: _vm.reserving },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }